import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ElementRef, ViewChild, inject, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ClarityModule } from '@clr/angular';
import { ColorPickerDirective } from 'ngx-color-picker';
import { ToastService } from 'src/app/services/toast.service';
import { firstValueFrom } from 'rxjs';
import { first } from 'rxjs/operators';
import { Table } from 'src/app/models/ui/table';

import { DotDotDotPipe } from 'src/app/pipes/dot-dot-dot.pipe';
import { GetByCallbackPipe } from 'src/app/pipes/get-by-callback.pipe';
import { HideIDColumnsPipe } from 'src/app/pipes/hide-idcolumns.pipe';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { APIService } from 'src/app/services/APIService/api.service';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { BasicStoreService } from 'src/app/services/BasicStore/basic-store.service';
import { ConfirmService } from 'src/app/services/confirm.service';
import { EncryptionService } from 'src/app/services/encryption.service';
import { FkColorsState } from 'src/app/services/fk-colors.state';
import { TextBoolDgCell } from '../../_shared/datagrid-cell/text-bool-dg-cell';
import { getTokenRight } from 'src/app/misc/functions';
import { TablePrettyPrintPipe } from '../../../../pipes/tablePrettyPrint.pipe';
import { error } from 'console';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-einstellungsmodal',
  templateUrl: './einstellungsmodal.component.html',
  styleUrls: ['./einstellungsmodal.component.scss'],
  imports: [
    CommonModule,
    ClarityModule,
    FormsModule,
    ReactiveFormsModule,
    ColorPickerDirective,
    GetByCallbackPipe,
    MrTranslatePipe,
    DotDotDotPipe,
    TextBoolDgCell,
    HideIDColumnsPipe,
    TablePrettyPrintPipe,
  ],
})
export class EinstellungsmodalComponent implements OnInit {
  private apiService = inject(APIService);
  private toastr = inject(ToastService);
  private authService = inject(AuthService);
  private mrTranslate = inject(MrTranslatePipe);
  private basicStore = inject(BasicStoreService);
  private encryptaes = inject(EncryptionService);
  private confirmService = inject(ConfirmService);

  private readonly fkColors = inject(FkColorsState);

  @Input() modalOpen: boolean = false;
  @Output() modalOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  isdev = signal(false);

  open(inData: any) {
    this.loadApiKeys();
    this.loadKAVSettings();
    this.loadKundenbezeichnung();
    this.loadINI();
    this.loadKunde();
    this.loadInterFaceOptions();
    this.trial = this.authService.getToken().trial;
    this.isdev.set(String(this.authService.getToken().dev).toLowerCase() === 'true');

    if (this.authService.twofa.value == 2) {
      this.optionGroup.controls.tfa.setValue(true);
    }
    this.headers.columns = [
      { id: 'ID', bezeichnung: 'ID' },
      { id: 'Bezeichnung', bezeichnung: 'Bezeichnung' },
      { id: 'Wert', bezeichnung: 'Wert' },
    ];
    this.modalOpen = true;
  }

  contentmode = 'allgemein';
  kundenbezeichnung: any;
  iniitems: any;
  ini: any;
  toSend: any;
  logo: any;
  base64Image: string;
  kunde: any = {
    k: '',
    o: '',
  };

  apiKeys: any = {
    bing: '',
    mapbox: '',
  };
  apiKeysOriginal: any = {};

  measurementUnitItems: string[] = ['Millimeter', 'Inch'];
  lengthUnitItems: string[] = ['Meter', 'Miles', 'Feet'];
  optAuthentType: number = 0;
  protected readonly allowInterfaces = getTokenRight(
    JSON.parse(this.authService.decrypt(localStorage.getItem('rights'))).program,
    'AllowPInterfEdit'
  );

  @ViewChild('bez') bez: ElementRef;
  @ViewChild('show') show: ElementRef;
  @ViewChild('must') must: ElementRef;

  headers: Table = { columns: [], rows: [] };
  headerid: Number = 0;
  Qualitaetsindex: Table;
  useQI: boolean = false;
  QIColor: string = '#FF0000';
  optionGroup: UntypedFormGroup = new UntypedFormGroup({
    kunde: new UntypedFormControl(''),
    ort: new UntypedFormControl(''),
    OpLogoDok: new UntypedFormControl(true),
    OpLogoPosition: new UntypedFormControl(true),
    OpMaxLenMangel: new UntypedFormControl(255),
    OpMaxLenInsthinweis: new UntypedFormControl(255),
    optZeitAuftragNummer: new UntypedFormControl(10),
    optChecked_EBL: new UntypedFormControl(false),
    optMeldung_EBL: new UntypedFormControl(false),
    optMeldungTage_EBL: new UntypedFormControl(0),
    optAuftragSpezExport: new UntypedFormControl(0),
    optRepscheinPicture: new UntypedFormControl(0),
    optAuftrWF: new UntypedFormControl(0),
    optDokSignatur: new UntypedFormControl(0),
    optAuthentType: new UntypedFormControl(0),
    ADAppid: new UntypedFormControl(''),
    ADTenant: new UntypedFormControl(''),
    optMINNumFK: new UntypedFormControl(1),
    optMAXNumFK: new UntypedFormControl(4),
    optFk1_IstGleich_BG: new UntypedFormControl(true),
    optDownChangeFK: new UntypedFormControl(true),
    optUnitLength: new UntypedFormControl(''),
    optUnitWidth: new UntypedFormControl(''),
    optUseFAT: new UntypedFormControl(false),
    tfa: new UntypedFormControl(false),
  });

  kavGroup: UntypedFormGroup = new UntypedFormGroup({
    gleisOffenerOberbauSchiene: new UntypedFormControl(0),
    gleisOffenerOberbauSchwellen: new UntypedFormControl(0),
    gleisOffenerOberbauBefestigung: new UntypedFormControl(0),
    gleisOffenerOberbauBettung: new UntypedFormControl(0),
    gleisOffenerOberbauUnterbau: new UntypedFormControl(0),
    gleisGeschlossenerOberbauSchiene: new UntypedFormControl(0),
    gleisGeschlossenerOberbauSchwellen: new UntypedFormControl(0),
    gleisGeschlossenerOberbauBefestigung: new UntypedFormControl(0),
    gleisGeschlossenerOberbauBettung: new UntypedFormControl(0),
    gleisGeschlossenerOberbauUnterbau: new UntypedFormControl(0),
    gleisGeschlossenerOberbauEindeckung: new UntypedFormControl(0),
    weichenSchiene: new UntypedFormControl(0),
    weichenSchwellen: new UntypedFormControl(0),
    weichenBefestigung: new UntypedFormControl(0),
    weichenBettung: new UntypedFormControl(0),
    weichenUnterbau: new UntypedFormControl(0),
    weichenZungenvorrichtung: new UntypedFormControl(0),
    weichenHerzstück: new UntypedFormControl(0),
    weichenEindeckung: new UntypedFormControl(0),
    kavKat1Color: new UntypedFormControl('#FF0000'),
    kavKat2Color: new UntypedFormControl('#FFFFFF'),
    kavKat3Color: new UntypedFormControl('#FFFFFF'),
    anzeigeKAV: new UntypedFormControl(false),
    anzeigeKAVDok: new UntypedFormControl(false),
    anzeigeTyp: new UntypedFormControl(0),
    useQI: new UntypedFormControl(0),
  });
  kavSettings: any = {};

  _optExportFormat: number = -1;
  _optExportFilter: number = 0;
  _optExportHeader: number = 0;

  fkcolor: string[] = [];
  regeln: any = [];
  regeln_po: any = [];
  regeln_mg: any = [];
  regeln_ih: any = [];
  regeln_sel: any = [];
  selectedRegel: any[] = [];
  labelLogin: string = 'Anmeldung';
  labelAuftrag: string = 'Auftrag erstellen';
  interfaceLogFiles: any = [];
  selectedfile: any;
  selectedHeader: any = undefined;

  defaultColors = [
    '#8B0000',
    '#FF0000',
    '#FFFF00',
    '#008000',
    '#0000FF',
    '#800080',
    '#FFA500',
    '#FFC0CB',
    '#808080',
    '#FF8C00',
    '#008080',
  ];

  interfaceGroup: UntypedFormGroup = new UntypedFormGroup({
    username: new UntypedFormControl('', [Validators.required]),
    passwort: new UntypedFormControl('', [Validators.required]),
    urllogin: new UntypedFormControl(''),
    urlmangel: new UntypedFormControl(''),
    urlmess: new UntypedFormControl(''),
    urlauftrag: new UntypedFormControl(''),
    urlstatus: new UntypedFormControl(''),
    urlshowmangel: new UntypedFormControl(''),
    urlshowauftrag: new UntypedFormControl(''),
    urlmergestamm: new UntypedFormControl(''),
    optExportFormat: new UntypedFormControl(-1),
    optExportFilter: new UntypedFormControl(0),
    optExportHeader: new UntypedFormControl(0),
    proi1: new UntypedFormControl(''),
    mart1: new UntypedFormControl(''),
    lart1: new UntypedFormControl(''),
    frist1: new UntypedFormControl(''),
    intervall1: new UntypedFormControl(''),
    proi2: new UntypedFormControl(''),
    mart2: new UntypedFormControl(''),
    lart2: new UntypedFormControl(''),
    frist2: new UntypedFormControl(''),
    intervall2: new UntypedFormControl(''),
    proi3: new UntypedFormControl(''),
    mart3: new UntypedFormControl(''),
    lart3: new UntypedFormControl(''),
    frist3: new UntypedFormControl(''),
    intervall3: new UntypedFormControl(''),
    proi4: new UntypedFormControl(''),
    mart4: new UntypedFormControl(''),
    lart4: new UntypedFormControl(''),
    frist4: new UntypedFormControl(''),
    intervall4: new UntypedFormControl(''),
    optExportFilterFK: new UntypedFormControl({}),
    optzedasgatt: new UntypedFormControl(0),
    optzedasmess: new UntypedFormControl(0),
    regel: new UntypedFormControl(''),
    regelart: new UntypedFormControl(''),
    regelwert: new UntypedFormControl(''),
    optSAPFieldTermin: new UntypedFormControl(false),
    optSAPFieldAusfall: new UntypedFormControl(false),
    optSAPFieldEquipment: new UntypedFormControl(false),
    optHexFieldUrsache: new UntypedFormControl(false),
    optHexFieldStörgrund: new UntypedFormControl(false),
    optHexFieldStörVon: new UntypedFormControl(false),
    optHexFieldStörBis: new UntypedFormControl(false),
    optHexFieldFestgestellt: new UntypedFormControl(false),
    headerWert: new UntypedFormControl(''),
    headerBezeichnung: new UntypedFormControl(''),

    optZFeld1Required: new UntypedFormControl(false),
    optZFeld2Required: new UntypedFormControl(false),
    optZFeld3Required: new UntypedFormControl(false),
    optZFeld4Required: new UntypedFormControl(false),
    optZFeld5Required: new UntypedFormControl(false),
    optZFeld1Title: new UntypedFormControl(''),
    optZFeld2Title: new UntypedFormControl(''),
    optZFeld3Title: new UntypedFormControl(''),
    optZFeld4Title: new UntypedFormControl(''),
    optZFeld5Title: new UntypedFormControl(''),
  });

  regelid: number = 0;
  trial = false;

  ngOnInit() {
    // if (this.authService.isLoggedIn()) {
    //   this.loadApiKeys();
    //   this.loadKAVSettings();
    //   this.loadKundenbezeichnung();
    //   this.loadINI();
    //   this.loadKunde();
    //   this.trial = this.authService.getToken().trial;
    //   if (this.authService.twofa == 2) {
    //     this.optionGroup.controls.tfa.setValue(true);
    //   }
    // }
  }

  trackHeaderItemById(items: any) {
    return items?.ID;
  }

  trackById = (index, item) => item.ID;

  trackFilesItem(items: any) {
    return items.name;
  }

  onFilterregelChange(val) {
    if (val.value == '1') {
      this.regeln_sel = this.regeln_mg;
    }
    if (val.value == '2') {
      this.regeln_sel = this.regeln_po;
    }
    if (val.value == '0') {
      this.regeln_sel = this.regeln_ih;
    }
  }
  replaceKundenfeld(s: string) {
    let t = this.mrTranslate.transform('Kundenfeld');
    return s.replace('KNField', t + ' ');
  }

  addHeader() {
    this.interfaceGroup.controls.headerBezeichnung.setValue('');
    this.interfaceGroup.controls.headerWert.setValue('');
  }

  saveHeader() {
    let v = this.interfaceGroup.value;

    const found = this.headers.rows.some(el => el.Bezeichnung === v.headerBezeichnung);
    if (!found) {
      this.headers.rows.push({
        ID: this.headers.rows.length + 1,
        Bezeichnung: v.headerBezeichnung,
        Wert: v.headerWert,
      });
      this.interfaceGroup.controls.headerBezeichnung.setValue('');
      this.interfaceGroup.controls.headerWert.setValue('');
    } else {
      this.toastr.error(v.headerBezeichnung + this.mrTranslate.transform(' existiert bereits'));
    }
  }

  async deleteHeader() {
    const ok = await this.confirmService.warning(
      this.mrTranslate.transform('Sind Sie sicher, dass Sie diesen Eintrag löschen wollen?')
    );
    if (ok) {
      const foundIndex = this.headers.rows.findIndex(f => f.ID === this.headerid);
      this.headers.rows = this.headers.rows.filter((_, index) => index !== foundIndex);
      let id = 1;
      this.headers.rows.forEach(object => {
        object.ID = id;
        id += 1;
      });
    }
  }

  selectionHeaderChanged(value: any) {
    if (value) {
      this.headerid = value.ID;
    }
  }

  addRegel() {
    this.regelid = 0;
    this.interfaceGroup.controls.regel.setValue('');
    this.interfaceGroup.controls.regelart.setValue('');
    this.interfaceGroup.controls.regelwert.setValue('');
  }

  getRegelnRows(val) {
    this.regeln.rows = [];

    setTimeout(() => {
      Object.keys(val).forEach(index => {
        let elem = val[index];

        if (elem.Regelart == 0) {
          elem.Regelart = this.mrTranslate.transform('Instandsetzung');
        }
        if (elem.Regelart == 1) {
          elem.Regelart = this.mrTranslate.transform('Mangel');
        }
        if (elem.Regelart == 2) {
          elem.Regelart = this.mrTranslate.transform('Prüfart');
        }

        elem.Regel = this.mrTranslate.transform(elem.Regel);

        this.regeln.rows.push(elem);
      });
    }, 1);
  }

  async deleteRegel() {
    const ok = await this.confirmService.danger(
      this.mrTranslate.transform('Sind Sie sicher, dass Sie diesen Regel löschen wollen?')
    );
    if (ok) {
      this.interfaceGroup.controls.regel.setValue('');
      this.interfaceGroup.controls.regelart.setValue('');
      this.interfaceGroup.controls.regelwert.setValue('');

      let send = {
        status: 'deleteregel',
        id: this.regelid,
      };

      this.apiService
        .getSettingsInterface(send)
        .pipe(first())
        .subscribe(res => {
          if (this.regeln.columns) {
            this.regeln.rows = res['regeln'].rows;
          } else this.regeln = res['regeln'];

          this.getRegelnRows(res['regeln'].rows);
          this.regelid = 0;
        });
    }
  }

  saveRegel() {
    let vals = this.interfaceGroup.value;

    if (vals.regelart.toString() == '') {
      this.toastr.error(this.mrTranslate.transform('Geben Sie eine Filterregel ein'));
      return;
    }
    if (vals.regel == '') {
      this.toastr.error(this.mrTranslate.transform('Geben Sie eine Regel ein'));
      return;
    }

    if (vals.regelwert == '') {
      this.toastr.error(this.mrTranslate.transform('Geben Sie eine Bezeichnung ein'));
      return;
    }

    let send = {
      status: 'saveregel',
      id: this.regelid,
      regelart: vals.regelart,
      regel: vals.regel,
      regelinhalt: vals.regelwert,
    };

    this.apiService
      .getSettingsInterface(send)
      .pipe(first())
      .subscribe(res => {
        if (this.regeln.columns) {
          this.regeln.rows = res['regeln'].rows;
        } else {
          this.regeln = res['regeln'];
        }

        this.getRegelnRows(res['regeln'].rows);
      });
  }

  trackRegelItemById(item: any): string | number {
    return item.ID;
  }

  selectionRegelChanged(value: any) {
    if (value != undefined) {
      const row = value[0] ?? null;

      this.regelid = row['ID'];

      if (row.Regelart == this.mrTranslate.transform('Instandsetzung')) {
        this.interfaceGroup.controls.regelart.setValue(0);
      }
      if (row.Regelart == this.mrTranslate.transform('Mangel')) {
        this.interfaceGroup.controls.regelart.setValue(1);
      }
      if (row.Regelart == this.mrTranslate.transform('Prüfart')) {
        this.interfaceGroup.controls.regelart.setValue(2);
      }

      if (row.Regel == this.mrTranslate.transform('enthält')) {
        this.interfaceGroup.controls.regel.setValue('enthält');
      } else this.interfaceGroup.controls.regel.setValue(row.Regel);

      this.interfaceGroup.controls.regelwert.setValue(row.Bezeichnung);
    }
  }

  getSum(mode: string) {
    switch (mode) {
      case 'gleisOffenerOberbau':
        return +(
          this.kavGroup.value.gleisOffenerOberbauSchiene +
          this.kavGroup.value.gleisOffenerOberbauSchwellen +
          this.kavGroup.value.gleisOffenerOberbauBefestigung +
          this.kavGroup.value.gleisOffenerOberbauBettung +
          this.kavGroup.value.gleisOffenerOberbauUnterbau
        ).toFixed(2);
      case 'gleisGeschlossenerOberbau':
        return +(
          this.kavGroup.value.gleisGeschlossenerOberbauSchiene +
          this.kavGroup.value.gleisGeschlossenerOberbauSchwellen +
          this.kavGroup.value.gleisGeschlossenerOberbauBefestigung +
          this.kavGroup.value.gleisGeschlossenerOberbauBettung +
          this.kavGroup.value.gleisGeschlossenerOberbauUnterbau +
          this.kavGroup.value.gleisGeschlossenerOberbauEindeckung
        ).toFixed(2);
      case 'weichen':
        return +(
          this.kavGroup.value.weichenSchiene +
          this.kavGroup.value.weichenSchwellen +
          this.kavGroup.value.weichenBefestigung +
          this.kavGroup.value.weichenBettung +
          this.kavGroup.value.weichenUnterbau +
          this.kavGroup.value.weichenZungenvorrichtung +
          this.kavGroup.value.weichenHerzstück +
          this.kavGroup.value.weichenEindeckung
        ).toFixed(2);
      default:
        return 0;
    }
  }

  loadKAVSettings() {
    this.apiService
      .getSettingsKav()
      .pipe(first())
      .subscribe((res: any) => {
        if (res) this.kavSettings = res;
        if (res && res.kav) {
          this.kavGroup.controls.gleisOffenerOberbauSchiene.setValue(parseFloat(res.kav.KAV1));
          this.kavGroup.controls.gleisOffenerOberbauSchwellen.setValue(parseFloat(res.kav.KAV2));
          this.kavGroup.controls.gleisOffenerOberbauBefestigung.setValue(parseFloat(res.kav.KAV5));
          this.kavGroup.controls.gleisOffenerOberbauBettung.setValue(parseFloat(res.kav.KAV3));
          this.kavGroup.controls.gleisOffenerOberbauUnterbau.setValue(parseFloat(res.kav.KAV4));
          this.kavGroup.controls.gleisGeschlossenerOberbauSchiene.setValue(parseFloat(res.kav.KAV11));
          this.kavGroup.controls.gleisGeschlossenerOberbauSchwellen.setValue(parseFloat(res.kav.KAV12));
          this.kavGroup.controls.gleisGeschlossenerOberbauBefestigung.setValue(parseFloat(res.kav.KAV15));
          this.kavGroup.controls.gleisGeschlossenerOberbauBettung.setValue(parseFloat(res.kav.KAV13));
          this.kavGroup.controls.gleisGeschlossenerOberbauUnterbau.setValue(parseFloat(res.kav.KAV14));
          this.kavGroup.controls.gleisGeschlossenerOberbauEindeckung.setValue(parseFloat(res.kav.KAV16));
          this.kavGroup.controls.weichenSchiene.setValue(parseFloat(res.kav.KAVW1));
          this.kavGroup.controls.weichenSchwellen.setValue(parseFloat(res.kav.KAVW3));
          this.kavGroup.controls.weichenBefestigung.setValue(parseFloat(res.kav.KAVW5));
          this.kavGroup.controls.weichenBettung.setValue(parseFloat(res.kav.KAVW4));
          this.kavGroup.controls.weichenUnterbau.setValue(parseFloat(res.kav.KAVW2));
          this.kavGroup.controls.weichenZungenvorrichtung.setValue(parseFloat(res.kav.KAVW7));
          this.kavGroup.controls.weichenHerzstück.setValue(parseFloat(res.kav.KAVW8));
          this.kavGroup.controls.weichenEindeckung.setValue(parseFloat(res.kav.KAVW6));
          this.kavGroup.controls.kavKat1Color.setValue('#' + res.kav.optKAVKat1ColS.toString(16));
          this.kavGroup.controls.kavKat2Color.setValue('#' + res.kav.optKAVKat2ColS.toString(16));
          this.kavGroup.controls.kavKat3Color.setValue('#' + res.kav.optKAVKat3ColS.toString(16));
          this.kavGroup.controls.anzeigeKAV.setValue(res.kav.KAV17);
          this.kavGroup.controls.anzeigeKAVDok.setValue(res.kav.KAV18);
          this.kavGroup.controls.anzeigeTyp.setValue(res.kav.optKAV_Anzeige_Typ);
          this.kavGroup.controls.useQI.setValue(res.kav.optKAVQI);

          this.useQI = res.kav.optKAVQI == 1;
        }

        this.Qualitaetsindex = res.qualitaetsindex;
      });
  }

  getLogFiles() {
    this.apiService
      .getLogFiles()
      .pipe(first())
      .subscribe(res => {
        if (res['success'] == true) {
          this.interfaceLogFiles = res['files'];
        } else {
          this.toastr.warning(this.mrTranslate.transform('Ein Fehler ist aufgetreten'));
        }
      });
  }

  loadSAPSynchronize = false;
  async doSAPSynchronize() {
    this.loadSAPSynchronize = true;
    const res = await firstValueFrom(this.apiService.getSAPSynchronize());

    this.loadSAPSynchronize = false;
    if (res['status'] == true) {
      if (res['errors'].length) {
        let txt = 'Anzahl der Mängel die synchronisiert wurden: ' + res['anzahl'] + '\n\n';
        txt += 'Fehler:\n';
        txt += res['errors'].join('\n ');
        txt += '\nsiehe Protokoll';

        await this.confirmService.warning(this.mrTranslate.transform(txt), false);
      } else {
        let txt = 'Anzahl der Mängel die synchronisiert wurden: ' + res['anzahl'];
        await this.confirmService.info(this.mrTranslate.transform(txt), false);
      }
    } else {
      this.toastr.error(this.mrTranslate.transform(res['error']));
    }
  }

  gethtmlData(base64: string): string {
    try {
      const binary = atob(base64);
      const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
      return new TextDecoder().decode(bytes);
    } catch (e) {
      console.error('Invalid base64', e);
      return 'Invalid data';
    }
  }

  trackQIById(row: any) {
    return row.ID;
  }

  selectedQI: any[] = [];
  stateQI: any | undefined;

  QI: UntypedFormGroup = new UntypedFormGroup({
    id: new UntypedFormControl(-1),
    index: new UntypedFormControl(0, [Validators.required]),
    von: new UntypedFormControl(0, [Validators.required]),
    bis: new UntypedFormControl(0, [Validators.required]),
    beschreibung: new UntypedFormControl('', [Validators.required]),
    color: new UntypedFormControl(255),
  });

  onUseQIChanged(event: Event): void {
    this.useQI = (event.target as HTMLInputElement).checked;
  }

  onColorChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.QIColor = input.value;
    this.QI.controls.color.setValue(input.value);
  }

  onDetailQI(value) {
    if (value != null) {
      this.QI.controls.id.setValue(value.ID);
      this.QI.controls.index.setValue(value.Note);
      this.QI.controls.von.setValue(value.von);
      this.QI.controls.bis.setValue(value.bis);
      this.QI.controls.beschreibung.setValue(value.Beschreibung);
      this.QI.controls.color.setValue(value.Farbe);

      this.QIColor = value.Farbe;
    }
  }

  addQualitaetsindex() {
    const lastItem = { ...this.Qualitaetsindex.rows[this.Qualitaetsindex.rows.length - 1] };
    let note = lastItem.Note;

    this.Qualitaetsindex.rows.push(lastItem);
    this.Qualitaetsindex.rows[this.Qualitaetsindex.rows.length - 1].ID = -1;
    this.Qualitaetsindex.rows[this.Qualitaetsindex.rows.length - 1].Note = +note + 1;
    this.stateQI = this.Qualitaetsindex.rows[this.Qualitaetsindex.rows.length - 1];
  }

  async deleteualitaetsindex() {
    const ok = await this.confirmService.warning(
      this.mrTranslate.transform('Sind Sie sicher, dass Sie diesen Eintrag löschen wollen?')
    );

    let vals = this.selectedQI[0];

    let send = {
      status: 'deleteitemsQI',
      id: vals.ID,
    };

    this.apiService
      .sendKAVsettings({
        kav: send,
        schwellen: null,
        schienenhoehe: null,
        anlagenklassen: null,
      })
      .pipe(first())
      .subscribe((res: any) => {
        if (res?.status) {
          let idToDelete = vals.ID;
          const index = this.Qualitaetsindex.rows.findIndex(item => item.id === idToDelete.ID);
          if (index !== -1) {
            this.Qualitaetsindex.rows.splice(index, 1);
          }
          this.toastr.warning(this.mrTranslate.transform('Daten wurden gelöscht'));
        } else this.toastr.error(this.mrTranslate.transform(res?.errors));
      });
  }

  saveQISettings() {
    this.QI.markAsTouched();
    if (this.QI.valid) {
      let vals = this.QI.value;

      let send = {
        status: 'saveitemsQI',
        items: vals,
      };

      this.apiService
        .sendKAVsettings({
          kav: send,
          schwellen: null,
          schienenhoehe: null,
          anlagenklassen: null,
        })
        .pipe(first())
        .subscribe((res: any) => {
          if (res?.status) this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
        });
    } else this.toastr.error(this.mrTranslate.transform('Eingaben fehlen'));
  }

  saveInterfaceSettings() {
    this.interfaceGroup.markAsTouched();
    this.interfaceGroup.updateValueAndValidity();
    if (this.interfaceGroup.valid) {
      let vals = this.interfaceGroup.value;

      let valHeader: string = '';
      if (vals.optExportHeader == 1) {
        valHeader = JSON.stringify(this.headers.rows);
      }

      if (vals.urllogin == '') {
        this.toastr.error(
          this.mrTranslate.transform('URL für Anmeldung fehlt'),
          this.mrTranslate.transform('URL fehlt!')
        );
        return;
      }

      if (vals.urlmangel == '') {
        this.toastr.error(
          this.mrTranslate.transform('URL für Mängel übertrage fehlt'),
          this.mrTranslate.transform('URL fehlt!')
        );
        return;
      }

      vals.ExportHeader = valHeader;

      let send = {
        status: 'saveitems',
        items: vals,
      };

      this.apiService
        .getSettingsInterface(send)
        .pipe(first())
        .subscribe(res => {
          if (res['success'] == true) {
            this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
            localStorage.setItem('optInterface', this.authService.encrypt(vals.optExportFormat));
          } else {
            this.toastr.warning(this.mrTranslate.transform('Ein Fehler ist aufgetreten'));
          }
        });
    } else this.toastr.error(this.mrTranslate.transform('Eingaben fehlen'));
  }

  saveKAVSettings() {
    let vals = this.kavGroup.value;
    let kav = {
      KAV1: vals.gleisOffenerOberbauSchiene,
      KAV2: vals.gleisOffenerOberbauSchwellen,
      KAV5: vals.gleisOffenerOberbauBefestigung,
      KAV3: vals.gleisOffenerOberbauBettung,
      KAV4: vals.gleisOffenerOberbauUnterbau,
      KAV11: vals.gleisGeschlossenerOberbauSchiene,
      KAV12: vals.gleisGeschlossenerOberbauSchwellen,
      KAV15: vals.gleisGeschlossenerOberbauBefestigung,
      KAV13: vals.gleisGeschlossenerOberbauBettung,
      KAV14: vals.gleisGeschlossenerOberbauUnterbau,
      KAV16: vals.gleisGeschlossenerOberbauEindeckung,
      KAV17: vals.anzeigeKAV,
      KAV18: vals.anzeigeKAVDok,
      KAVW1: vals.weichenSchiene,
      KAVW3: vals.weichenSchwellen,
      KAVW5: vals.weichenBefestigung,
      KAVW4: vals.weichenBettung,
      KAVW2: vals.weichenUnterbau,
      KAVW7: vals.weichenZungenvorrichtung,
      KAVW8: vals.weichenHerzstück,
      KAVW6: vals.weichenEindeckung,
      optKAVKat1ColS: parseInt(vals.kavKat1Color.slice(1), 16),
      optKAVKat2ColS: parseInt(vals.kavKat2Color.slice(1), 16),
      optKAVKat3ColS: parseInt(vals.kavKat3Color.slice(1), 16),
      optKAV_Anzeige_Typ: vals.anzeigeTyp,
      optKAVQI: vals.useQI,
    };

    let schwellen = this.kavSettings.schwellen
      .map(schwelle => {
        return `${schwelle.Schwellenart}\t${schwelle['max. Liegedauer']}\r`;
      })
      .join('\n');
    let schienenhoehe = this.kavSettings.schienenhoehe;
    let anlagenklassen = this.kavSettings.anlagenklasse;

    this.apiService
      .sendKAVsettings({
        kav: kav,
        schwellen: schwellen,
        schienenhoehe: schienenhoehe,
        anlagenklassen: anlagenklassen,
      })
      .pipe(first())
      .subscribe((res: any) => {
        if (res?.status) this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
      });
  }

  loadApiKeys() {
    this.apiService
      .getSettingsApiKeys()
      .pipe(first())
      .subscribe(res => {
        this.apiKeys = res;
        this.apiKeysOriginal = JSON.parse(JSON.stringify(res));
      });
  }

  loadInterFaceOptions() {
    this.apiService
      .getSettingsInterface({ status: 'get' })
      .pipe(first())
      .subscribe(res => {
        this.regeln = res['regeln'];
        this.getRegelnRows(res['regeln'].rows);

        if (res['ini']) {
          let ini = res['ini'].rows[0];
          this.interfaceGroup.controls.username.setValue(ini.user);
          this.interfaceGroup.controls.passwort.setValue(ini.pwort);
          this.interfaceGroup.controls.urllogin.setValue(ini.urllogin);
          this.interfaceGroup.controls.urlmangel.setValue(ini.urllogin0);
          this.interfaceGroup.controls.urlmess.setValue(ini.urlmess);
          this.interfaceGroup.controls.urlauftrag.setValue(ini.urlauftrag);
          this.interfaceGroup.controls.urlstatus.setValue(ini.urlstatus);
          this.interfaceGroup.controls.urlshowmangel.setValue(ini.urlshowmangel);
          this.interfaceGroup.controls.urlshowauftrag.setValue(ini.urlshowauftrag);
          this.interfaceGroup.controls.urlmergestamm.setValue(ini.urlmergestamm);
          this.interfaceGroup.controls.optExportFormat.setValue(ini.optExportFormat);
          this.interfaceGroup.controls.optExportFilter.setValue(ini.optExportFilter);
          this.interfaceGroup.controls.optExportHeader.setValue(ini.optExportHeader);
          this.interfaceGroup.controls.proi1.setValue(ini.proi1);
          this.interfaceGroup.controls.proi2.setValue(ini.proi2);
          this.interfaceGroup.controls.proi3.setValue(ini.proi3);
          this.interfaceGroup.controls.proi4.setValue(ini.proi4);
          this.interfaceGroup.controls.mart1.setValue(ini.mart1);
          this.interfaceGroup.controls.mart2.setValue(ini.mart2);
          this.interfaceGroup.controls.mart3.setValue(ini.mart3);
          this.interfaceGroup.controls.mart4.setValue(ini.mart4);
          this.interfaceGroup.controls.lart1.setValue(ini.lart1);
          this.interfaceGroup.controls.lart2.setValue(ini.lart2);
          this.interfaceGroup.controls.lart3.setValue(ini.lart3);
          this.interfaceGroup.controls.lart4.setValue(ini.lart4);
          this.interfaceGroup.controls.frist1.setValue(ini.frist1);
          this.interfaceGroup.controls.frist2.setValue(ini.frist2);
          this.interfaceGroup.controls.frist3.setValue(ini.frist3);
          this.interfaceGroup.controls.frist4.setValue(ini.frist4);
          this.interfaceGroup.controls.optExportFilterFK.setValue(JSON.parse(ini.optExportFilterFK));
          this.interfaceGroup.controls.optzedasgatt.setValue(ini.optzedasgatt);
          this.interfaceGroup.controls.optzedasmess.setValue(ini.optzedasmess);
          this.interfaceGroup.controls.optSAPFieldTermin.setValue(ini.optSAPFieldTermin);
          this.interfaceGroup.controls.optSAPFieldAusfall.setValue(ini.optSAPFieldAusfall);
          this.interfaceGroup.controls.optSAPFieldEquipment.setValue(ini.optSAPFieldEquipment);
          this.interfaceGroup.controls.optHexFieldUrsache.setValue(ini.optHexFieldUrsache);
          this.interfaceGroup.controls.optHexFieldStörgrund.setValue(ini.optHexFieldStörgrund);
          this.interfaceGroup.controls.optHexFieldStörVon.setValue(ini.optHexFieldStörVon);
          this.interfaceGroup.controls.optHexFieldStörBis.setValue(ini.optHexFieldStörBis);
          this.interfaceGroup.controls.optHexFieldFestgestellt.setValue(ini.optHexFieldFestgestellt);

          this.interfaceGroup.controls.optZFeld1Required.setValue(ini.optZFeld1Required);
          this.interfaceGroup.controls.optZFeld2Required.setValue(ini.optZFeld2Required);
          this.interfaceGroup.controls.optZFeld3Required.setValue(ini.optZFeld3Required);
          this.interfaceGroup.controls.optZFeld4Required.setValue(ini.optZFeld4Required);
          this.interfaceGroup.controls.optZFeld5Required.setValue(ini.optZFeld5Required);

          this.interfaceGroup.controls.optZFeld1Title.setValue(ini.optZFeld1Title);
          this.interfaceGroup.controls.optZFeld2Title.setValue(ini.optZFeld2Title);
          this.interfaceGroup.controls.optZFeld3Title.setValue(ini.optZFeld3Title);
          this.interfaceGroup.controls.optZFeld4Title.setValue(ini.optZFeld4Title);
          this.interfaceGroup.controls.optZFeld5Title.setValue(ini.optZFeld5Title);

          this._optExportFormat = ini.optExportFormat > 100 ? 1 : ini.optExportFormat;
          this.interfaceGroup.controls.optExportFormat.setValue(this._optExportFormat);

          this._optExportFilter = ini.optExportFilter;
          this._optExportHeader = ini.optExportHeader;

          if (ini.ExportHeader) {
            if (ini.ExportHeader != '') {
              this.headers.rows = JSON.parse(ini.ExportHeader);
            }
          }

          if (this._optExportFormat == 3) {
            this.labelLogin = 'Web-Link';
            this.labelAuftrag = 'Auftrag';
          }
        }
        this.regeln_po = res['po'];
        this.regeln_mg = res['mg'];
        this.regeln_ih = res['ih'];
        this.regeln_sel = [];
      });
  }

  loadKunde() {
    this.apiService
      .getSettingsKunde()
      .pipe(first())
      .subscribe(res => {
        this.kunde = res;
        this.optionGroup.controls.kunde.setValue(this.kunde.k);
        this.optionGroup.controls.ort.setValue(this.kunde.o);
      });
  }

  loadKundenbezeichnung() {
    this.apiService
      .getKundenBezeichnung()
      .pipe(first())
      .subscribe(res => {
        this.kundenbezeichnung = res;
      });
  }

  get fkMap(): { [key: string]: boolean } {
    return this.interfaceGroup.get('optExportFilterFK')?.value ?? {};
  }

  get fehlerklassen(): string[] {
    return Object.keys(this.fkMap);
  }

  onCheckboxChange(key: string, checked: boolean): void {
    const current = { ...this.fkMap };
    current[key] = checked;

    this.interfaceGroup.get('optExportFilterFK')?.setValue(current);
  }

  onChangeLogoDok(event) {
    this.iniitems.isOpLogoDok = event.target.checked;
  }

  onInterfaceFilterChanged(event, opj) {
    let vals = this.interfaceGroup.value;
    this._optExportFilter = vals.optExportFilter;
  }

  onInterfaceHeadersChanged(event, opj) {
    let vals = this.interfaceGroup.value;
    this._optExportHeader = vals.optExportHeader;
  }

  onInterfaceChanged(event, opj) {
    let vals = this.interfaceGroup.value;
    this._optExportFormat = vals.optExportFormat;
    this.labelLogin = 'Anmeldung';
    if (this._optExportFormat == 3) {
      this.labelLogin = 'Web-Link';
      this.labelAuftrag = 'Auftrag';
    }
  }

  onAnmeldChanged(event, opj) {
    let t = event.target.checked;
    this.optAuthentType = 0;
    if (opj != 'mrpro') {
      if (event.target.checked) {
        this.optAuthentType = 2;
      }
    }
  }

  changeStatus(event) {
    let t = event.target.checked;
    let n = 0;

    if (t) {
      n = 2;
    }

    let iniVal = {
      status: 'updatetwofa',
      googletwofa: n,
    };

    this.apiService
      .sendINIsettings({
        ini: iniVal,
      })
      .pipe(first())
      .subscribe((res: any) => {
        if (res?.status) {
          this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
        } else {
          this.toastr.warning(res.join('<br>'), this.mrTranslate.transform('Ein Fehler ist aufgetreten'));
        }
      });
  }

  saveINI() {
    let vals = {
      ...this.optionGroup.value,
      ADAppid: (this.optionGroup.value.ADAppid ?? '').trim(),
      ADTenant: (this.optionGroup.value.ADTenant ?? '').trim(),
    };

    this.optionGroup.controls.ADAppid.setValue(vals.ADAppid, { emitEvent: false });
    this.optionGroup.controls.ADTenant.setValue(vals.ADTenant, { emitEvent: false });

    this.optAuthentType = vals.optAuthentType;

    if (vals.optAuthentType == 2) {
      if (vals.ADAppid == '') {
        this.toastr.error(this.mrTranslate.transform('Geben Sie eine App ID ein'));
        return;
      }
      if (!this.isGuid(vals.ADAppid)) {
        this.toastr.error(this.mrTranslate.transform('Geben Sie eine gültige App ID/Client ID ein'));
        return;
      }
      if (vals.ADTenant == '') {
        this.toastr.error(this.mrTranslate.transform('Geben Sie eine Tenant ID oder Tenant-Domäne ein'));
        return;
      }
      if (!this.isValidTenant(vals.ADTenant)) {
        this.toastr.error(this.mrTranslate.transform('Geben Sie eine gültige Tenant ID oder Tenant-Domäne ein'));
        return;
      }
    }

    if (vals.optUseFAT == false) {
      vals.optUseFAT = 0;
      localStorage.setItem('optUseFAT', '0');
    } else {
      localStorage.setItem('optUseFAT', '1');
    }

    let iniVal = {
      BetreiberlogoBase64: '',
      OpLogoDok: vals.OpLogoDok,
      OpLogoPosition: parseFloat(vals.OpLogoPosition),
      OpMaxLenMangel: vals.OpMaxLenMangel,
      OpMaxLenInsthinweis: vals.OpMaxLenInsthinweis,
      optChecked_EBL: vals.optChecked_EBL,
      optMeldung_EBL: vals.optMeldung_EBL,
      optMeldungTage_EBL: vals.optMeldungTage_EBL,
      optAuftragSpezExport: vals.optAuftragSpezExport,
      optRepscheinPicture: vals.optRepscheinPicture,
      optAuftrWF: vals.optAuftrWF,
      optDokSignatur: vals.optDokSignatur,
      ADAppid: vals.ADAppid,
      ADTenant: vals.ADTenant,
      optMINNumFK: vals.optMINNumFK,
      optMAXNumFK: vals.optMAXNumFK,
      optFk1_IstGleich_BG: vals.optFk1_IstGleich_BG,
      optDownChangeFK: vals.optDownChangeFK,
      optZeitAuftragNummer: vals.optZeitAuftragNummer,
      optAuthentType: vals.optAuthentType,
      optUnitLength: Number(vals.optUnitLength),
      optUnitWidth: Number(vals.optUnitWidth),
      optUseFAT: Number(vals.optUseFAT),
      FKColors: this.fkcolor.join(';'),
    };

    if (this.base64Image) {
      iniVal.BetreiberlogoBase64 = this.base64Image;
    }

    if (vals.ADTenant) {
      iniVal.ADTenant = vals.ADTenant;
    }

    if (vals.ADAppid) {
      iniVal.ADAppid = vals.ADAppid;
    }

    let kunde = {
      name: vals.kunde,
      ort: vals.ort,
    };

    this.apiService
      .sendINIsettings({
        ini: iniVal,
        kunde: kunde,
      })
      .pipe(first())
      .subscribe((res: any) => {
        if (res?.status) {
          this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
          this.basicStore.setComponentStore('einstellung', {
            einstellung: iniVal,
          });
          this.fkColors.reload();
        } else {
          this.toastr.warning(res.join('<br>'), this.mrTranslate.transform('Ein Fehler ist aufgetreten'));
        }
      });
  }

  loadINI() {
    this.apiService
      .getINIOptions()
      .pipe(first())
      .subscribe(res => {
        this.ini = res;
        this.iniitems = this.ini?.rows[0];
        if (!this.iniitems) return;
        this.optionGroup.controls.OpLogoDok.setValue(this.iniitems.OpLogoDok);

        if (this.iniitems.OpLogoPosition == 1) this.optionGroup.controls.OpLogoPosition.setValue('1');
        else this.optionGroup.controls.OpLogoPosition.setValue('0');

        this.optionGroup.controls.OpMaxLenMangel.setValue(parseFloat(this.iniitems.OpMaxLenMangel));
        this.optionGroup.controls.OpMaxLenInsthinweis.setValue(parseFloat(this.iniitems.OpMaxLenInsthinweis));
        this.optionGroup.controls.optZeitAuftragNummer.setValue(parseFloat(this.iniitems.optZeitAuftragNummer));
        this.optionGroup.controls.optChecked_EBL.setValue(this.iniitems.optChecked_EBL);
        this.optionGroup.controls.optMeldung_EBL.setValue(this.iniitems.optMeldung_EBL);
        this.optionGroup.controls.optMeldungTage_EBL.setValue(parseFloat(this.iniitems.optMeldungTage_EBL));
        this.optionGroup.controls.optAuftragSpezExport.setValue(this.iniitems.optAuftragSpezExport);
        this.optionGroup.controls.optRepscheinPicture.setValue(this.iniitems.OptRepscheinPicture);
        this.optionGroup.controls.optAuftrWF.setValue(this.iniitems.optAuftrWF ?? 0);
        this.optionGroup.controls.optDokSignatur.setValue(this.iniitems.optDokSignatur ?? 0);
        this.optionGroup.controls.ADAppid.setValue(this.iniitems.ADAppid);
        this.optionGroup.controls.ADTenant.setValue(this.iniitems.ADTenant);
        this.optionGroup.controls.optMINNumFK.setValue(parseFloat(this.iniitems.optMINNumFK));
        this.optionGroup.controls.optMAXNumFK.setValue(parseFloat(this.iniitems.optMAXNumFK));
        this.optionGroup.controls.optFk1_IstGleich_BG.setValue(this.iniitems.optFk1_IstGleich_BG);
        this.optionGroup.controls.optDownChangeFK.setValue(this.iniitems.optDownChangeFK);
        this.optionGroup.controls.optAuthentType.setValue(this.iniitems.optAuthentType);
        this.optionGroup.controls.optUnitLength.setValue(this.iniitems.optUnitLength);
        this.optionGroup.controls.optUnitWidth.setValue(this.iniitems.optUnitWidth);
        this.fkcolor = this.iniitems.optFKColors ? this.iniitems.optFKColors.split(';') : this.defaultColors;

        localStorage.setItem('optUseFAT', this.iniitems.optUseFAT?.toString());

        this.optAuthentType = this.iniitems.optAuthentType;
        if (this.iniitems.optUseFAT.toString() == '0') {
          this.optionGroup.controls.optUseFAT.setValue(false);
        } else {
          this.optionGroup.controls.optUseFAT.setValue(true);
        }

        if (this.iniitems.BetreiberlogoBase64) {
          this.logo = 'data:image/png;base64,' + this.iniitems.BetreiberlogoBase64;
          this.base64Image = this.iniitems.BetreiberlogoBase64;
        }
      });
  }
  private isGuid(value: string): boolean {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);
  }

  private isValidTenant(value: string): boolean {
    return this.isGuid(value) || /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/i.test(value);
  }

  onLogoChanged(event) {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        let r = reader.result as String;
        const splitted = r.split(',');
        this.base64Image = splitted[1];
        this.logo = r;
      };
      reader.readAsDataURL(file);
    }
  }

  colorFocusInput(input: HTMLInputElement) {
    input.focus();
    input.click();
  }

  saveBezeichnung(id: number) {
    let b = this.bez.nativeElement.value;
    let s = this.show.nativeElement.checked;
    let m = this.must.nativeElement.checked;

    if (id < 13) {
      if (this.bez.nativeElement.value == '') {
        this.toastr.error(this.mrTranslate.transform('Bezeichnung darf nicht leer sein'));
        return;
      }
    } else {
      if (this.bez.nativeElement.value == '') {
        s = false;
        m = false;
      }
    }

    if (b != '') {
      for (let i = 0; i < this.kundenbezeichnung.rows.length; i++) {
        let bez = this.kundenbezeichnung.rows[i];
        if (bez.ID !== id) {
          if (bez.KBezeichnung.toLowerCase() === b.toLowerCase()) {
            this.toastr.error(this.mrTranslate.transform('Bezeichnung wird bereits verwendet'));
            return;
          }
        }
      }
    }

    let toSend = {};

    toSend['ID'] = id;
    toSend['KBezeichnung'] = b;
    toSend['KShow'] = s;
    toSend['KPflicht'] = m;

    this.apiService
      .setSettingsBezeichnung(toSend)
      .pipe(first())
      .subscribe((res: any) => {
        if (res.status && res.status == 'OK') {
          this.loadKundenbezeichnung();

          this.toastr.success(this.mrTranslate.transform('Bezeichnung erfolgreich gespeichert.'));
        } else {
          this.toastr.warning(res.join('<br>'), this.mrTranslate.transform('Ein Fehler ist aufgetreten'));
        }
      });
  }

  protected readonly range = ({ start, stop, step = 1 }: { start: number; stop: number; step?: number }) =>
    Array.from({ length: Math.ceil((stop + 1 - start) / step) }, (_, i) => start + i * step);

  setColorFromPicker(i: number) {}
  saveApiKeys() {
    let send = {};

    Object.keys(this.apiKeys).forEach(key => {
      if (this.apiKeysOriginal[key] != this.apiKeys[key]) {
        send[key] = this.apiKeys[key];
      }
    });

    this.apiService
      .setSettingsApiKeys(send)
      .pipe(first())
      .subscribe((res: any) => {
        if (res.length == 0) {
          this.apiKeysOriginal = JSON.parse(JSON.stringify(this.apiKeys));
          this.toastr.success(this.mrTranslate.transform('Einstellungen erfolgreich gespeichert.'));
        } else {
          this.toastr.warning(res.join('<br>'), this.mrTranslate.transform('Ein Fehler ist aufgetreten'));
        }
      });
  }
}
